//@flow
const debug = require('../../debug/debug')('wc:util:runner:BackgroundJobRunner');

export default class BackgroundJobRunner {
  idleIntervalInSeconds: number;
  focusTimeStamp: number;
  blurTime: number;
  intervalInSeconds: number;
  timerId: any;
  jobs: Map<string, Function>;
  paused: boolean;
  pauseReason: ?string;
  refreshOnFocus: boolean;

  constructor(intervalInSeconds: number = 120, idleIntervalInSeconds: number = 600) {
    this.intervalInSeconds = intervalInSeconds;
    this.idleIntervalInSeconds = idleIntervalInSeconds;
    this.timerId = 0;
    this.focusTimeStamp = Date.now();
    this.jobs = new Map();
    this.paused = false;
    if (window) {
      window.addEventListener('focus', this.onWindowFocus);
      window.addEventListener('blur', this.onWindowBlur);
    }
    this.refreshOnFocus = true;
    this.setupTimer();
  }

  setupTimer() {
    if (this.timerId === 0) {
      this.timerId = setInterval(this.onTick, this.intervalInSeconds * 1000);
      debug('Timer setup done. Timer id:', this.timerId);
    }
  }

  onWindowFocus = (event: Event) => {
    this.focusTimeStamp = Date.now();
    debug('Window is in focus.');
    this.setupTimer();
    if (BackgroundJobRunner.JOB_RUNNER.refreshOnFocus) this.onTick();
  };

  onWindowBlur = (event: Event) => {
    debug('Window blurred.');
    this.blurTime = Date.now();
    this.stopTimer();
  };

  onTick = () => {
    if (this.isIdle()) {
      this.stopTimer();
    } else {
      this.runJobs();
    }
  };

  addJob(name: string, job: Function): void {
    this.jobs.set(name, job);
    debug('Background Job Added: ', name, 'Total Jobs:', this.jobs.size);
  }

  removeJob(name: string): void {
    this.jobs.delete(name);
    debug('Background Job Removed: ', name, 'Total Jobs:', this.jobs.size);
  }

  resume() {
    this.paused = false;
    this.pauseReason = undefined;
  }

  pause(reason: string) {
    this.paused = true;
    this.pauseReason = reason;
  }

  /**
   * @private
   */
  runJobs() {
    if (this.paused) {
      debug('Jobs are paused. Reason: ', this.pauseReason);
      return;
    }
    this.jobs.forEach(BackgroundJobRunner.runJob);
  }

  /**
   * @private
   */
  static runJob(value: Function, name: string): void {
    debug('Running job: ', name);
    setTimeout(value, 0);
  }

  stopTimer() {
    clearInterval(this.timerId);
    this.timerId = 0;
  }

  isIdle(): boolean {
    debug(this.focusTimeStamp, this.blurTime);
    if (this.focusTimeStamp < this.blurTime) {
      const currentTime = Date.now();
      const idleTime = (currentTime - this.blurTime) / 1000;
      if (idleTime >= this.idleIntervalInSeconds) {
        debug('App is in idle mode for more than: ', idleTime, 'seconds');
        return true;
      }
    }
    return false;
  }

  static JOB_RUNNER: BackgroundJobRunner;

  static updateConfigs(
    refreshOnFocus: boolean = true,
    intervalInSeconds: number = 120,
    idleIntervalInSeconds: number = 600
  ) {
    if (intervalInSeconds > 0 && idleIntervalInSeconds > 0) {
      this.JOB_RUNNER.intervalInSeconds = intervalInSeconds;
      this.JOB_RUNNER.idleIntervalInSeconds = idleIntervalInSeconds;
      this.JOB_RUNNER.refreshOnFocus = refreshOnFocus;
    }
  }
}

BackgroundJobRunner.JOB_RUNNER = new BackgroundJobRunner();
